import { Button } from "primereact/button";

import { buttonNext, formSetRegisterPassword } from "../../_constants";

export const SetPasswordBtn = () => {
  return (
    <div className="flex-container justify-end">
      <Button
        label={buttonNext}
        className="container-button"
        form={formSetRegisterPassword}
      ></Button>
    </div>
  );
};
